<template>
  <div class="fill-height text-center d-flex flex-column justify-space-around px-6 all-container">
    <div class="success--text text--darken-2">
      <h1>{{ $t('GAME.QUIZ.OVER') }}</h1>
      <!-- <h2>+{{ $store.getters['quiz/score'] }} {{ $t('GAME.POINTS')}}</h2> -->
    </div>

    <div class="d-flex justify-center">
    </div>

    <div>
      <BaseButton
        class="my-5"
        @click="$router.back()"
      >
        {{ $t('BACK') }}
      </BaseButton>
    </div>
  </div>
</template>

<style scoped>
.all-container {
  margin: auto;
  max-width: 500px;
  width: 100%;
}
</style>

<script>
export default {
  name: 'QuizGameOver',
};
</script>
